import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Vdoimg from '../../assets/images/background/video-three-bg-img.jpg'

function VideoTwo() {

  const [show, setshow] = useState(false)


  return (
    <div>
      <section className="video-two video-three">
        <div className="video-two-img-box">
          <div className="scroll_item_select_img">
            <img
              src={Vdoimg}
              alt=""
            />
          </div>
        </div>
        <div className="container">
          <div className="video-two-btn" onClick={() => setshow(true)}>
            <Link
              to=""
              className="video-popup video-play"
            >
              <i className="icon-play" />
            </Link>
          </div>
        </div>
      </section>

      {show &&
        <div className="YouTubePopUp-Wrap">
          <div className="YouTubePopUp-Content" onClick={() => setshow(false)}>
            <span className="YouTubePopUp-Close" onClick={() => setshow(false)}/>
            <iframe
              src="https://www.youtube.com/embed/rzfmZC3kg3M?autoplay=1"
              allowFullScreen=""
            />
          </div>
        </div>
      }
    </div>
  )
}

export default VideoTwo
